import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useMainSelection, resetMainSelection, useEditingStateWithCtx } from '@/atoms'
import { fitMapToSelection } from '@/map'
import { selectOrderStepsListStructure } from '@/features/domain/lists'

export function useTitle() {
  const listStructure = useSelector(selectOrderStepsListStructure)
  const { editing } = useEditingStateWithCtx('order')

  const [selection, select] = useMainSelection('orderSteps')

  const onSelectAll = useCallback(() => {
    const allSelected = listStructure.shownItems <= selection.length

    if (allSelected) {
      resetMainSelection('orderSteps')
    } else {
      select(
        listStructure.list.reduce<string[]>((acc, item) => {
          if (typeof item === 'string') {
            acc.push(item)
          }
          return acc
        }, []),
      )

      fitMapToSelection({ preventIfVisible: true }, 'add')
    }
  }, [select, selection, listStructure])

  return {
    editing,
    selection,
    onSelectAll,
    listStructure,
    noEntries: listStructure.totalItems === 0,
  }
}
